"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
exports.MembershipPoints__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var ethers_1 = require("ethers");
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "passId",
                type: "uint256"
            },
            {
                indexed: true,
                internalType: "int256",
                name: "amount",
                type: "int256"
            },
            {
                indexed: false,
                internalType: "address",
                name: "operator",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "MembershipPointsNow",
                type: "uint256"
            },
            {
                indexed: false,
                internalType: "address",
                name: "ownerNow",
                type: "address"
            },
        ],
        name: "MembershipPointsEvent",
        type: "event"
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "passId",
                type: "uint256"
            },
        ],
        name: "getMembershipPoints",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
];
var _bytecode = "0x608060405234801561001057600080fd5b5061012d806100206000396000f3fe6080604052348015600f57600080fd5b506004361060285760003560e01c80637d58d62214602d575b600080fd5b60436004803603810190603f919060a9565b6057565b604051604e919060de565b60405180910390f35b6000806000838152602001908152602001600020549050919050565b600080fd5b6000819050919050565b6089816078565b8114609357600080fd5b50565b60008135905060a3816082565b92915050565b60006020828403121560bc5760bb6073565b5b600060c8848285016096565b91505092915050565b60d8816078565b82525050565b600060208201905060f1600083018460d1565b9291505056fea2646970667358221220ca1d76e4f652a6997c5f9660d0157c004c96a3c72a6012b736856c1d340e9ba864736f6c634300080d0033";
var isSuperArgs = function (xs) { return xs.length > 1; };
var MembershipPoints__factory = /** @class */ (function (_super) {
    __extends(MembershipPoints__factory, _super);
    function MembershipPoints__factory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = this;
        if (isSuperArgs(args)) {
            _this = _super.apply(this, args) || this;
        }
        else {
            _this = _super.call(this, _abi, _bytecode, args[0]) || this;
        }
        return _this;
    }
    MembershipPoints__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    MembershipPoints__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    MembershipPoints__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    MembershipPoints__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    MembershipPoints__factory.createInterface = function () {
        return new ethers_1.utils.Interface(_abi);
    };
    MembershipPoints__factory.connect = function (address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    };
    MembershipPoints__factory.bytecode = _bytecode;
    MembershipPoints__factory.abi = _abi;
    return MembershipPoints__factory;
}(ethers_1.ContractFactory));
exports.MembershipPoints__factory = MembershipPoints__factory;
